var linearProgressThemeWeb = {
  color: 'primary',
  height: 8,
  borders: {
    radius: 'borders.radius'
  },
  bar: {
    inactiveColor: 'text.disabled'
  }
};

export { linearProgressThemeWeb };
